function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property(target, key, source[key]);
        });
    }
    return target;
}
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React, { useContext } from 'react';
import { useSelector } from 'react-redux';
import { FormattedMessage } from 'react-intl';
import { ProfileContext } from 'context';
import Avatar from 'components/Avatar';
import Button from 'components/Form/Button';
import ExclamationNegative from 'svg/exclamation-negative.svg';
import Loader from 'svg/loader.svg';
import Account from 'modules/Account';
import messages from '../../../messages';
import styles from '../DownloadDataModal.pcss';
import { useIsProfileActivationInProgress } from './hooks';
const PatientData = ()=>{
    const profileContext = useContext(ProfileContext);
    const patientProfile = useSelector(profileContext.selectors.activePatient);
    const isProfileActivationInProgress = useIsProfileActivationInProgress();
    if (isProfileActivationInProgress) {
        return /*#__PURE__*/ _jsx(Loader, {
            className: `${styles.results__patientLoader} rotatingLoader`
        });
    }
    if (!patientProfile) {
        return /*#__PURE__*/ _jsxs("div", {
            className: styles.results__noPatient,
            children: [
                /*#__PURE__*/ _jsx(ExclamationNegative, {
                    className: styles.results__noPatient__icon
                }),
                /*#__PURE__*/ _jsx("span", {
                    children: /*#__PURE__*/ _jsx(FormattedMessage, _object_spread({}, messages.labels.noPatientMatched))
                })
            ]
        });
    }
    const { avatar, firstName, lastName } = patientProfile;
    return /*#__PURE__*/ _jsxs("div", {
        className: "row align-items-center",
        children: [
            /*#__PURE__*/ _jsx("div", {
                className: "col-auto pr-0",
                children: /*#__PURE__*/ _jsx(Avatar, {
                    avatarBase64: avatar,
                    name: [
                        firstName,
                        lastName
                    ],
                    className: styles.results__avatar,
                    imgClassName: styles.results__avatar__img,
                    initialsClassName: styles.results__avatar__initials
                })
            }),
            /*#__PURE__*/ _jsx("div", {
                className: "col",
                children: /*#__PURE__*/ _jsxs("p", {
                    "data-hj-suppress": true,
                    className: styles.results__patient__name,
                    children: [
                        firstName,
                        " ",
                        lastName
                    ]
                })
            })
        ]
    });
};
const ChoosePatient = ({ onSetComponent })=>{
    const profileContext = useContext(ProfileContext);
    const activeProfileType = useSelector(Account.selectors.activeProfileType);
    const isPwd = activeProfileType === Account.constants.PROFILE_TYPES.PWD;
    const patientProfile = useSelector(profileContext.selectors.activePatient);
    const activeVisit = useSelector(profileContext.selectors.activeVisit);
    if (isPwd || activeVisit) {
        return null;
    }
    const onChoosePatient = ()=>onSetComponent('ChoosePatient');
    return /*#__PURE__*/ _jsx("div", {
        className: "col text--right",
        children: /*#__PURE__*/ _jsx(Button, {
            styleModifier: "transparent",
            labelMessage: patientProfile ? messages.buttons.changePatient : messages.buttons.choosePatient,
            className: "btn--no-size text--primary m-0",
            onClick: onChoosePatient,
            id: "choosePatient"
        })
    });
};
const Patient = (props)=>/*#__PURE__*/ _jsx("div", {
        className: styles.results__patient,
        children: /*#__PURE__*/ _jsxs("div", {
            className: styles.results__patient__inner,
            children: [
                /*#__PURE__*/ _jsx("div", {
                    className: "col",
                    children: /*#__PURE__*/ _jsx(PatientData, {})
                }),
                /*#__PURE__*/ _jsx("div", {
                    className: "col",
                    children: /*#__PURE__*/ _jsx(ChoosePatient, _object_spread({}, props))
                })
            ]
        })
    });
export default Patient;
